// Delay before triggering bbox reloads after map movement events.
export const BBOX_RELOAD_DEBOUNCE_MS = 250;
// Maximum wait time before forcing a bbox reload during continuous movement.
export const BBOX_RELOAD_MAX_WAIT_MS = 1000;
